(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-flourish-section]').forEach(root => {
      if(root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const menu = root.querySelector('.flourish-mobile-menu');
      const toggle = root.querySelector('.flourish-menu-button');
      if(toggle && menu){
        toggle.addEventListener('click',()=>{const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;});
        menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{menu.hidden=true;toggle.setAttribute('aria-expanded','false');}));
        root.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.focus();}});
      }
      const tabs=[...root.querySelectorAll('[data-bar-tab]')];
      const panels=[...root.querySelectorAll('[data-bar-panel]')];
      const stage=root.querySelector('.flourish-product-stage');
      const mobile=window.matchMedia('(max-width:800px)');
      const previous=root.querySelector('[data-bar-previous]');
      const next=root.querySelector('[data-bar-next]');
      const count=root.querySelector('[data-bar-count]');
      let active=Math.max(0,tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true'));
      const updateSelection=index=>{
        active=index;
        tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
        if(count)count.textContent=`${index+1} / ${panels.length}`;
        if(previous)previous.disabled=index===0;
        if(next)next.disabled=index===panels.length-1;
      };
      const activate=id=>{
        const index=panels.findIndex(panel=>panel.dataset.barPanel===id);
        if(index<0)return;
        updateSelection(index);
        if(mobile.matches&&stage){
          const offset=panels[index].offsetLeft-panels[0].offsetLeft;
          stage.scrollTo({left:offset,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        }else panels.forEach((panel,i)=>{panel.hidden=i!==index;});
      };
      root.activateFlourishBar=activate;
      const syncLayout=()=>{
        panels.forEach((panel,i)=>{
          panel.hidden=!mobile.matches&&i!==active;
          panel.setAttribute('role',mobile.matches?'group':'tabpanel');
          panel.querySelectorAll('.flourish-product-more').forEach(details=>{details.open=true;});
        });
        if(stage){
          stage.tabIndex=mobile.matches?0:-1;
          stage.scrollLeft=mobile.matches&&panels.length?panels[active].offsetLeft-panels[0].offsetLeft:0;
        }
        updateSelection(active);
      };
      const revealHash=()=>{
        const id=decodeURIComponent(location.hash.slice(1));
        if(!id)return;
        const panel=panels.find(p=>p.id===id||p.querySelector(`[id="${CSS.escape(id)}"]`));
        if(panel)activate(panel.dataset.barPanel);
      };
      if(tabs.length){
        syncLayout();
        revealHash();
        mobile.addEventListener('change',syncLayout);
        window.addEventListener('hashchange',revealHash);
        previous?.addEventListener('click',()=>activate(panels[Math.max(0,active-1)].dataset.barPanel));
        next?.addEventListener('click',()=>activate(panels[Math.min(panels.length-1,active+1)].dataset.barPanel));
        let scrollFrame=0;
        stage?.addEventListener('scroll',()=>{
          if(!mobile.matches)return;
          cancelAnimationFrame(scrollFrame);
          scrollFrame=requestAnimationFrame(()=>{
            const origin=panels[0].offsetLeft;
            let nearest=0;
            panels.forEach((panel,i)=>{if(Math.abs(panel.offsetLeft-origin-stage.scrollLeft)<Math.abs(panels[nearest].offsetLeft-origin-stage.scrollLeft))nearest=i;});
            updateSelection(nearest);
          });
        },{passive:true});
        stage?.addEventListener('keydown',e=>{
          if(!mobile.matches||e.target!==stage)return;
          if(e.key==='ArrowRight'||e.key==='ArrowLeft'){
            e.preventDefault();
            activate(panels[Math.min(panels.length-1,Math.max(0,active+(e.key==='ArrowRight'?1:-1)))].dataset.barPanel);
          }
        });
      }
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab.dataset.barTab));
        tab.addEventListener('keydown',e=>{
          let nextIndex;
          if(e.key==='ArrowRight'||e.key==='ArrowDown')nextIndex=(index+1)%tabs.length;
          else if(e.key==='ArrowLeft'||e.key==='ArrowUp')nextIndex=(index-1+tabs.length)%tabs.length;
          else if(e.key==='Home')nextIndex=0;
          else if(e.key==='End')nextIndex=tabs.length-1;
          else return;
          e.preventDefault();activate(tabs[nextIndex].dataset.barTab);tabs[nextIndex].focus();
        });
      });
    });
  };
  let cartRequest = 0;
  document.addEventListener('cart:update', async () => {
    const counter = document.querySelector('[data-flourish-cart-count]');
    const link = counter?.closest('[data-cart-url]');
    if (!link) return;
    const request = ++cartRequest;
    try {
      const response = await fetch(`${link.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (request === cartRequest) document.querySelectorAll('[data-flourish-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    } catch {}
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[data-bar-panel]');const root=panel?.closest('[data-flourish-section]');if(root?.activateFlourishBar)root.activateFlourishBar(panel.dataset.barPanel);});
})();
